export const enClientPortalOrderSidebarPages = {
    orders: {
        orderSidebar: {
            overview: 'Overview',
        },
    },
}
